export default __webpack_public_path__ + "static/media/pic_love.d143e43f.png";